import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const slide = trigger('slide', [
  state('void', style({ opacity: 0, top: 20 })),
  state('closed', style({ opacity: 0, top: 20 })),
  state('open', style({ opacity: 1, top: 0 })),
  transition('* <=> *', animate('100ms')),
]);
